import * as React from 'react';
import { cloneElement, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Datagrid,
  FunctionField,
  TextField,
  ReferenceField,
  BooleanField,
  Filter,
  SearchInput,
  Button,
  EditButton,
  DeleteButton,

  useListContext,
  useRefresh,
  useNotify,
  TopToolbar,
  CreateButton,
  sanitizeListRestProps,
  usePermissions,
} from 'react-admin';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import hasPermission from '../shared/hasPermission';
import { sanitizeButtonProps } from '../shared/sanitizeReactProps';
import List from '../shared/SimappList';

const API_URL = process.env.REACT_APP_API_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ScientificLiteratureKeywordActions = props => {
  const {
    className,
    exporter,
    filters,
    maxResults,
    ...rest
  } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    hasCreate,
    basePath,
    selectedIds,
    showFilter,
    total,
  } = useListContext();
  const { permissions } = usePermissions();

  return hasPermission(permissions, { create: ['/api/web/scientific_literature_keywords'] })
    ? (
      <TopToolbar
        className={className}
        {...sanitizeListRestProps(rest)}
      >
        {filters && cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
        <CreateButton basePath={basePath} />
      </TopToolbar>
    ) : null;
};

const ScientificLiteratureKeywordFilter = props => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

const ScientificLiteratureKeywordList = props => {
  const { permissions } = usePermissions();

  return (
    <List
      {...props}
      title="Scientific Literature"
      filters={<ScientificLiteratureKeywordFilter />}
      actions={<ScientificLiteratureKeywordActions />}
      sort={{ order: 'DESC', field: 'id' }}
    >
      <Datagrid>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <FunctionField
          label="Actions"
          textAlign="right"
          render={record => (
            <ButtonGroup>
              {hasPermission(permissions, { update: ['/api/web/scientific_literature_keywords/'] })
            && (
              <EditButton
                {...sanitizeButtonProps(props)}
                title="Edit"
                label={null}
                record={record}
              />
            )}
              {hasPermission(permissions, { delete: ['/api/web/scientific_literature_keywords/'] })
            && (
              <DeleteButton
                {...sanitizeButtonProps(props)}
                title="Delete"
                undoable={false}
                label={null}
                record={record}
              />
            )}
            </ButtonGroup>
          )}
        />
      </Datagrid>
    </List>
  );
};

export default ScientificLiteratureKeywordList;
